import React, { useState, useEffect, useRef } from "react";
import Logo from "../../assets/img/logo.png";

const Header = () => {
  const [disabled, setDisabled] = useState(false);
  const ref = useRef(null);

  const handleClick = () => {
    setDisabled(!disabled);
    if (!disabled) alert("Sorry! something went wrong!");
    else alert(" Sorry! something went wrong!");
  };

  useEffect(() => {
    const element = ref.current;
    if (element) {
      element.addEventListener("click", () => {
        element.classList.add("active-filter");
        const siblings =
          element.parentNode.getElementsByClassName("filter-item");
        siblings.forEach((sibling) =>
          sibling.classList.remove("active-filter")
        );
      });
    }
  }, [ref]);

  // const handleSubscribeClick = () => {
  //   const loginFormRef = document.querySelector(".subscribe-form");
  //   loginFormRef.classList.toggle("active");
  // };

  useEffect(() => {
    const header = document.querySelector("header");

    const handleScroll = () => {
      header.classList.toggle("shadow", window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/*  Header */}
      <header>
        <div className="nav container">
          <a href="#home" className="logo">
            <img src={Logo} alt="logo" className="logo-img" />
            Bee<span>Tech</span>
          </a>
          <a
            href="#1"
            className="btn active-filter"
            id="subscribe-btn"
            disabled={disabled}
            onClick={handleClick}
            // onClick={handleSubscribeClick}
          >
            subscribe
          </a>
        </div>

        <div className="subscribe-form">
          <h3>newsletter</h3>
          <p>subscribe for latest updates</p>
          <input type="email" placeholder="your email" className="email" />
          <input
            type="submit"
            value="subscribe"
            className="btn active-filter"
          />
        </div>
      </header>
    </>
  );
};

export default Header;
